package fr.frux.feature.treedetail

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect

/** Relaie la position de l'arbre une fois chargée, puis à chaque déplacement (édition). */
@Composable
internal fun TreeLocatedEffect(
    latitude: Double?,
    longitude: Double?,
    onTreeLocated: (latitude: Double, longitude: Double) -> Unit,
) {
    LaunchedEffect(latitude, longitude) {
        if (latitude != null && longitude != null) onTreeLocated(latitude, longitude)
    }
}
